import React, { useState } from 'react';

interface Tab {
  id?: string;
  key?: string;
  label: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
}

interface TabsProps {
  tabs?: Tab[];
  items?: Tab[];
  defaultTab?: string;
  onChange?: (tabId: string) => void;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs: tabsProp,
  items,
  defaultTab,
  onChange,
}) => {
  // Support both 'tabs' and 'items' props, and both 'id' and 'key' fields
  const tabs = (tabsProp || items || []).map(t => ({
    ...t,
    id: t.id || t.key || '',
  }));
  
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    onChange?.(tabId);
  };

  const activeContent = tabs.find(t => t.id === activeTab)?.content;

  return (
    <div>
      {/* Tab headers */}
      <div className="relative">
        <div className="flex border-b border-gray-200 overflow-x-auto scrollbar-none">
          {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={`
              flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors
              whitespace-nowrap
              ${activeTab === tab.id
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
        </div>
        <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-white to-transparent pointer-events-none sm:hidden" />
      </div>
      
      {/* Tab content */}
      <div className="mt-4">
        {activeContent}
      </div>
    </div>
  );
};

export default Tabs;
